<template>
  <div class="plant-wrapper">
    <div class="plant-wrapper-top">
      <div class="handle-wrapper" @click="backPath">
        <div class="icon-font">&#xe612;</div>
        返回
      </div>
      <div class="plant-wrapper-top-title">变更历史</div>
      <div class="handle-wrapper" style="opacity: 0">
        <span class="back-logo"></span>返回
      </div>
    </div>
    <div class="select-wrapper">
      <div class="history-select-top">
        <div style="margin-right: 1vw">
          <DropDown
            :content="warehouseTitle"
            :items="warehouse"
            @sendInfo="showInfoW"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            :content="buildingTitle"
            :items="building"
            @sendInfo="showInfoB"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            :content="floorTitle"
            :items="floor"
            @sendInfo="showInfoF"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            :content="areaTitle"
            :items="area"
            @sendInfo="showInfoA"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            :content="stackTitle"
            :items="stack"
            @sendInfo="showInfoS"
          ></DropDown>
        </div>
      </div>
      <div class="history-select-bottom">
        <div style="margin-right: 1vw; position: relative; z-index: 7">
          <DropDown
            content="请选择状态"
            :items="statusData"
            v-on:sendInfo="showInfoStatus"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw; position: relative; z-index: 7">
          <DropDown
            content="请选择虫情类型"
            :items="typeData"
            v-on:sendInfo="showInfoType"
          ></DropDown>
        </div>
        <div class="input-date-wrapper">
          <el-date-picker
            v-model="value"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="query button" @click="handleSearch(1)">查询</div>
      </div>
    </div>
    <div class="detail">
      <div class="detail-box">
        <div class="loading-data" v-if="loading">
          <i class="el-icon-loading"></i>
          <div>加载中，请稍后···</div>
        </div>
        <div class="detail-nav">
          <div class="detail-item" style="width: 5%">序号</div>
          <div class="detail-item" style="width: 10%">虫情板ID</div>
          <div class="detail-item" style="width: 10%">虫情类型</div>
          <div class="detail-item" style="width: 20%">仓库位置</div>
          <div class="detail-item" style="width: 10%">负责人</div>
          <div class="detail-item" style="width: 10%">创建日期</div>
          <div class="detail-item" style="width: 15%">到期日期</div>
          <div class="detail-item" style="width: 10%">状态</div>
          <div class="detail-item" style="width: 10%">备注</div>
        </div>
        <div class="detail-content">
          <div
            class="detail-list-wrapper"
            v-if="!loading && tableData.length > 0"
            v-for="(data, index) in tableData"
            :key="index"
          >
            <div class="detail-item" style="width: 5%">{{ index + 1 }}</div>
            <div class="detail-item" style="width: 10%">
              {{ data.pestBoardId }}
            </div>
            <div class="detail-item" style="width: 10%">
              {{
                data.boardType 
              }}
            </div>
            <div class="detail-item" style="width: 20%">
              {{ data.siteName }}
            </div>
            <div class="detail-item" style="width: 10%">
              {{ data.principalName }}
            </div>
            <div class="detail-item" style="width: 10%">
              {{ data.createTime }}
            </div>
            <div class="detail-item" style="width: 15%">
              {{ data.useTimeEnd }}
            </div>
            <div
              class="detail-item"
              style="width: 10%"
              :class="{
                'color-red': data.isExpire === 0,
                'color-green': data.isExpire === 1,
              }"
            >
              {{ data.isExpire === 0 ? "已到期" : "未到期" }}
            </div>
            <div class="detail-item" style="width: 10%" v-if="!data.remark">
              --
            </div>
            <div class="detail-item" style="width: 10%" v-if="data.remark">
              <el-popover
                placement="top"
                title=""
                trigger="hover"
                :content="data.remark"
              >
                <div class="popover" slot="reference">{{ data.remark }}</div>
              </el-popover>
            </div>
          </div>
          <div class="none-data" v-if="!loading && tableData.length < 1">
            暂无数据
          </div>
        </div>
        <div class="page-wrapper" v-if="!loading && total > rows">
          <div class="page-wrapper-left">
            共{{ total }}条数据,共{{ Allpages }}页，每页显示{{
              rows
            }}条，当前第{{ page }}页
          </div>
          <div class="page-wrapper-right">
            <div class="page-btn" @click="firstPage">首页</div>
            <div class="page-btn" @click="previousPage">上一页</div>
            <div class="page-btn" @click="Tzpage">跳转至</div>
            <div class="page-btn">
              <input @blur="Tzpage" v-model="page" />
            </div>
            <div class="page-btn" @click="nextPage">下一页</div>
            <div class="page-btn" @click="lastPage">尾页</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from "../../../components/DropDownSingle.vue";
import { warehouseNode } from "../../../api/basic";
import { queryHistory } from "../../../api/maintain";
export default {
  name: "ChangeHistory",
  components: { DropDown },
  data() {
    return {
      value: "",
      warehouse: [],
      building: [],
      floor: [],
      area: [],
      stack: [],
      warehouseTitle: "请选择仓库",
      buildingTitle: "请选择楼号",
      floorTitle: "请选择层号",
      areaTitle: "请选择区号",
      stackTitle: "请选择垛位",
      statusData: [
        { name: "全部", value: "" },
        { name: "到期", value: 0 },
        { name: "未到期", value: 1 },
      ],
      typeData: [
        { name: "全部", value: "" },
        { name: "蛾虫", value: "01" },
        { name: "甲虫", value: "02" },
        { name: "粉虫", value: "03" },
        { name: "其他", value: "04" },
      ],
      loading: true,
      pestBoardId: "",
      startDate: "",
      endDate: "",
      siteId: "",
      siteType: "",
      boardType: "",
      status: "",
      page: 1,
      rows: 8,
      total: "",
      // 总页数
      Allpages: 0,
      tableData: [],
    };
  },
  watch: {
    value: function () {
      this.startDate = this.value !== null ? this.value[0] : "";
      this.endDate = this.value !== null ? this.value[1] : "";
    },
  },
  created() {
    this.pestBoardId = this.$route.query.pestBoardId;
    let body = {
      warehouseNodeId: "",
      warehouseNodeType: "01",
    };
    warehouseNode(body)
      .then((res) => {
        this.warehouse = res.data;
        this.handleSearch(1);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    showInfoStatus: function (data) {
      this.status = data.value;
    },
    showInfoType: function (data) {
      this.boardType = data.value;
    },
    showInfoW: function (data) {
      this.warehouseTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "02",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.building = res.data;
          this.buildingTitle = "请选择楼号";
          this.floor = [];
          this.floorTitle = "请选择层号";
          this.area = [];
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoB: function (data) {
      this.buildingTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "03",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.floor = res.data;
          this.floorTitle = "请选择层号";
          this.area = [];
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoF: function (data) {
      this.floorTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "04",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          this.area = res.data;
          this.areaTitle = "请选择区号";
          this.stack = [];
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoA: function (data) {
      this.areaTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
      let body = {
        warehouseNodeId: data.id,
        warehouseNodeType: "05",
      };
      warehouseNode(body)
        .then((res) => {
          console.log(res);
          res.data.map((item) => {
            item.sign = 0;
          });
          this.stack = res.data;
          this.stackTitle = "请选择垛位";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    showInfoS: function (data) {
      this.stackTitle = data.name;
      this.siteId = data.id;
      this.siteType = data.siteType;
    },
    handleSearch: function (type) {
      if (type === 1) {
        this.page = 1;
      }
      let body = {
        pestBoardId: this.pestBoardId,
        page: this.page,
        rows: this.rows,
        siteId: this.siteId,
        siteType: this.siteType,
        boardType: this.boardType,
        status: this.status,
        startDate: this.startDate,
        endDate: this.endDate,
      };
      this.loading = true;
      queryHistory(body)
        .then((res) => {
          console.log(res);
          res.data.rows &&
            res.data.rows.map((item) => {
              item.sign = 0;
            });
          this.tableData = res.data.rows || [];
          this.total = res.data.total;
          this.loading = false;
          this.all = false;
          this.idList = [];
          // 计算总页数
          this.Allpages = Math.ceil(this.total / this.rows);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    backPath: function () {
      this.$router.go(-1);
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
        this.handleSearch();
      }
    },
    Tzpage: function () {
      console.log("跳转页面");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else if (this.page >= this.Allpages) {
        this.$message({
          message: "总页数为" + this.Allpages,
          type: "warning",
          center: "true",
          duration: "1000",
        });
        this.page = this.Allpages;
        this.handleSearch();
      } else {
        this.handleSearch();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        this.handleSearch();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        this.handleSearch();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        this.handleSearch();
      }
    },
  },
};
</script>

<style scoped>
@import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/ChangeHistory.vue